import React from "react";
import { DebugLog } from "@me8eon/debug";
import { WindowUrlData } from "@me8eon/routing";
import { GetterSetter, makeContextFor, makeContextForState } from "@me8eon/context";
import { parseAttributeValue } from "@me8eon/string_utils";


//example filter data
// {
//    time: "yesterday"
//    status: "open"
//    searchtext: "hello"
//}

export type FiltersPlugins<Filters> = {
    [Key in keyof Filters]: FiltersPlugin<Pick<Filters, Key>, Key>;
};


export type FiltersPlugin<Filters, FilterName extends keyof Filters> = {
    plugin: "filter"
    type: FilterName
    DefaultDisplay: DisplayFilter<Filters[FilterName]> | null
    changeCausesSubmit: boolean
    deleteWhenClean: boolean
    fromUrl?: (debug: DebugLog, s: WindowUrlData, def: Filters[FilterName]) => Filters[FilterName]
    addToUrl?: (debug: DebugLog, u: URLSearchParams, f: Filters[FilterName]) => void
}

export function filterValuesThatCauseSubmit<Filters>(filterPlugIns: FiltersPlugins<Filters>, filters: Filters): Partial<Filters> {
    const result: Partial<Filters> = {};
    for (const key in filters) {
        const { attribute, value } = parseAttributeValue(key);
        const filter = filterPlugIns[attribute as keyof Filters];
        if (filter.changeCausesSubmit) {
            result[key] = filters[key];
        }
    }
    return result;
}


export type DisplayFiltersProps<Filters> = { rootId: string, filtersOps: GetterSetter<Filters> }
/** The type for the component that displays a lot of filters*/
export type DisplayFilters<Filters> = (props: DisplayFiltersProps<Filters>) => React.ReactElement


//the value appears if we have a thing like agg:priority in the data view declaration
export type DisplayFilterProps<Filter> = { rootId?: string, filterOps: GetterSetter<Filter>; filterName: string, value?: string }
/** The type for diplaying one filter */
export type DisplayFilter<Filter> = (props: DisplayFilterProps<Filter>) => React.ReactElement


export type FilterLayoutProps = { rootId: string; children: React.ReactNode }
export type FilterLayout = (props: FilterLayoutProps) => React.ReactElement


export const { Provider: FilterPluginsProvider, use: useFilterPlugins } = makeContextFor<FiltersPlugins<any>, "filterPlugins">("filterPlugins");
export const { Provider: GuiFilterProvider, use: useGuiFilters } = makeContextForState<Record<string, string>, "guiFilters">("guiFilters", {debug:false, showStackTrace: false});

